var PrimusEvent = {}
// 竖版事件
// 用于处理红点
PrimusEvent.Updata_Primus_RedPoint = "PrimusEvent.Updata_Primus_RedPoint"

module.exports = PrimusEvent;